import moment from 'moment';

export const getFormattedDate = (date) => {
    return new Date(date)
        .toLocaleString('en-GB', {
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true // set to true for 12-hour format (AM/PM)
        })
        .replace(',', '')
        .replace(/\b(am|pm)\b/, (match) => match.toUpperCase()); // ✅ converts am/pm to AM/PM
};

export const getFormattedOnlyDate = (date) => {
    return new Date(date)
        .toLocaleString('en-GB', {
            weekday: 'short',
            month: 'short',
            day: '2-digit'
        })
        .replace(',', '')
        .replace(/\b(am|pm)\b/, (match) => match.toUpperCase()); // ✅ converts am/pm to AM/PM
};

export const standardDate = (date) => {
    return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
};
